import alt from 'components/Dispatcher';
import { hashHistory } from 'react-router';
let $ = window.$;
class ProductActions{
  fetchProducts() {
    return true;
  }
  updateProducts(products) {
    return products;
  }
  updateFeatureId(feature_id){
    return feature_id;
  }
  updateFetchType(type){
    return type;
  }
  clearType(){
    return true;
  }
  fetchSlides(){
    return true;
  }
  updateSlides(slides){
    return {slides}
  }
  fetchProduct(id) {
    return id;
  }
  fetchTeams(id) {
    return id;
  }
  fetchComments(id){
    return id;
  }
  updateTeams(teams) {
    return {teams}
  }
  updateComments(comments) {
    return {comments}
  }
  updateProductOffset(offset){
    return offset;
  }
  updateProductPlanOffset(offset){
    return offset;
  }
  updateProductCommentOffset(offset){
    return offset;
  }
  updateProductTipsOffset(offset){
    return offset;
  }
  clearProduct(){
    return true;
  }
  clearProducts(){
    return true;
  }
  setLoading(loading) {
    return loading;
  }
  updateAllProducts(products){
    return products;
  }
  updateProduct(res) {
    if(res.status) {
      this.fetchError(res);
      return false;
    } else {
      return res.result;
    }
  }
  fetchLoading() {
    return {loading: true};
  }
  fetchSlideSuccess(res) {
    if(res.status){
      this.fetchError(res);
    }else{
      this.updateSlides(res.result);
    }
    return false;
  }
  fetchTeamsSuccess(res) {
    if(res.status){
      this.fetchError(res);
    }else{
      this.updateTeams(res.result);
    }
    return false;
  }
  fetchCommentsSuccess(res) {
    if(res.status){
      this.fetchError(res);
    }else{
      this.updateComments(res.result);
    }
    return false;
  }
  fetchSuccess(res) {
    if(res.status) {
      this.fetchError(res);
    } else {
      this.updateProducts(res.result);
    }
    return false;
  }
  refreshProduct(json) {
    return true;
  }
  fetchError(res) {
    if(res.status === 403) {
      hashHistory.push('/login');
    }
    return res;
  }
}

export default alt.createActions(ProductActions);



// WEBPACK FOOTER //
// ./src/actions/ProductActions.js